export default "__VITE_ASSET__B03yrkZ3__"